// extracted by mini-css-extract-plugin
export default {"input":"MonthInput_input__uH3uH"};